/** Adapted from standalone-search f83fe2d1 via selected Registrar V2. See docs/delivery/iteration2/fusion-shared-kit/TRANSFER.json. */
import * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-card border-input flex h-[var(--control-height)] w-full min-w-0 rounded-control border bg-transparent px-3 py-1 text-body shadow-none transition-[color,box-shadow] outline-none file:inline-flex file:h-[var(--control-height-compact)] file:border-0 file:bg-transparent file:text-ui file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-ui",
        "focus-visible:border-ring focus-visible:ring-ring focus-visible:ring-2",
        "aria-invalid:ring-destructive dark:aria-invalid:ring-destructive aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
